import { Link } from 'react-router-dom';
import React from 'react';
import { Phone, Calendar, Clock, Shield } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY_INFO } from '../../data/mock';

export const CTASection = ({ variant = 'default' }) => {
  const isEmergency = variant === 'emergency';

  return (
    <section className={`py-16 md:py-20 ${
      isEmergency
        ? 'bg-gradient-to-br from-amber-500 to-orange-600'
        : 'bg-gradient-to-br from-brand-blue to-blue-700'
    }`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-6">
          {isEmergency ? (
            <Clock className="w-12 h-12 mx-auto text-white/90 mb-4" />
          ) : (
            <Phone className="w-12 h-12 mx-auto text-white/90 mb-4" />
          )}
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {isEmergency 
            ? "Need Emergency Sprinkler Repair?" 
            : "Ready to Fix Your Irrigation System?"}
        </h2>
        
        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          {isEmergency
            ? "We offer after-hours emergency service for urgent sprinkler problems. Don't let a leak or break cause water damage."
            : "Contact AAA Irrigation Service today for expert sprinkler repair and maintenance. TCEQ Licensed and fully insured."}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Button
            asChild
            size="lg"
            className="bg-white text-teal-700 hover:bg-slate-100 shadow-xl hover:shadow-2xl transition-all duration-300 text-lg px-8 py-6 h-auto"
          >
            <a href={`tel:${COMPANY_INFO.phone}`}>
              <Phone className="w-5 h-5 mr-2" />
              Call {COMPANY_INFO.phoneFormatted}
            </a>
          </Button>
          
          <Button
            asChild
            size="lg"
            variant="outline"
            className="bg-white/10 border-white text-white hover:bg-white/20 transition-all duration-300 text-lg px-8 py-6 h-auto"
          >
            <Link to={COMPANY_INFO.bookingUrl}>
              <Calendar className="w-5 h-5 mr-2" />
              Schedule Online
            </Link>
          </Button>
        </div>

        <div className="flex items-center justify-center gap-2 text-white/80">
          <Shield className="w-4 h-4" />
          <a 
            href={COMPANY_INFO.licenseUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm hover:text-white transition-colors"
          >
            TCEQ Licensed: {COMPANY_INFO.license}
          </a>
        </div>
      </div>
    </section>
  );
};
